
import { ykDateFormat } from '@/public/utils/globalFunc.js'

// 导入excel日期格式化
export function ykImportFormat(str, fmt) {
  if (Number(str)) {
    if (str > 18264) {
      let date = new Date((str - 25567) * 24 * 3600000 - 1439 * 60 * 1000 - 43 * 1000 - 24 * 3600000 - 8 * 3600000)
      let format = 'yyyy-MM-dd'
      if (fmt) {
        format = fmt
      }
      return ykDateFormat(format, date)
    } else {
      return ''
    }
  } else {
    return str
  }
}